function imageLoader({ src }) {
  return src; // REPLACE WITH YOUR IMAGE DIRECTORY
}
module.exports = imageLoader;